import styled from '@emotion/styled';
import { colors, spacing, typography } from '../../../../../themes';

export const FileUploadStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${spacing.xxsmall};
`;

export const FileUploadStatusText = styled.span`
  ${typography.body.large}
  color: ${colors.primary.grey};
`;
